import CreateDemat from "./CreateDemat";
import { Context } from '../../../services/apiContext';
import { useContext, useEffect, useState } from "react";
import configData from '../../../utils/config/config.json';

export function CreateDematPage() {
    const contextapi = useContext(Context);
    const userRefererId = contextapi.getSession('userRefId');
    const [referrer, setReferrer] = useState();

    useEffect(() => {
        const getReferrer = async (refid) => {
            let newData = {};
            newData.Transaction_id = refid;
        
            var getData = {
              data: newData,
              url: configData.baseURLDev + '/logos/gettransactiondetails',
            };
        
            var url = configData.baseURLProxy;
        
            await contextapi
              .postApiAuthCalling(url, getData, false)
              .then((res) => {
                console.log(res);
                setReferrer(res.data);
              })
              .catch((error) => {
                console.log(error);
              });
          };
        if (userRefererId) {
            getReferrer(userRefererId).then(function() {});
        }
    }, []);

    if (!userRefererId) {
        return (<CreateDemat />)
    } else {
        if (!!referrer) {
            return <CreateDemat referrer={referrer} />
        } else {
            return <p>Loading...</p>;
        }
    }
}